// استيراد Outlet لعرض المكونات الفرعية و useNavigate للتنقل
import { Outlet, useNavigate } from "react-router-dom";
// استيراد مكتبة إدارة الكوكيز
import Cookie from "cookie-universal";
// استيراد دوال React لإدارة الحالات والتأثيرات الجانبية والتخزين المؤقت
import { useContext, useEffect, useState, useCallback } from "react";

// استيراد رابط API الخاص بالمستخدم
import { USER } from "../../../API/Api";
// استيراد مكون التحميل
import Loding from "../../../components/Loading/Loding";
// استيراد كائن Axios المهيأ
import { Axios } from "../../../API/Axios";
// استيراد مكون خطأ 403
import Error403 from "../Errors/403";
// استيراد سياق المستخدم الحالي
import { CurrentUserContext } from "../../../Context/CurrentUserContext";

// مكون المصادقة المطلوبة - يتحقق من صلاحيات المستخدم
export default function RequierAuth ( { allowedRole } )
{
    // دالة للتنقل بين الصفحات
    const navigate = useNavigate();
    // إنشاء كائن للتعامل مع الكوكيز
    const cookie = Cookie();
    // الحصول على رمز المصادقة من الكوكيز
    const token = cookie.get( "ecommerce" );

    // استخدام سياق المستخدم الموروث من المكون الأب (إذا كان موجوداً)
    // هذا يمنع إرسال طلب /user مكرر في الراوتات المتداخلة
    const inheritedUser = useContext( CurrentUserContext );

    // حالة محلية لتخزين بيانات المستخدم
    const [ localUser, setLocalUser ] = useState( null );

    // دالة لجلب بيانات المستخدم من الخادم - يتم تخزينها مؤقتاً باستخدام useCallback
    const fetchUser = useCallback( () =>
    {
        // إرسال طلب GET لجلب بيانات المستخدم
        Axios.get( `/${ USER }` )
            .then( ( res ) => setLocalUser( res.data ) ) // تخزين بيانات المستخدم في الحالة
            .catch( () => navigate( "/auth", { replace: true } ) ); // في حالة الخطأ التوجيه لصفحة المصادقة
    }, [ navigate ] ); // إعادة إنشاء الدالة عند تغيير دالة التنقل

    // تأثير جانبي للتحقق من المصادقة وجلب بيانات المستخدم
    useEffect( () =>
    {
        // إذا كان المستخدم موروثاً من السياق، لا حاجة لجلب البيانات
        if ( inheritedUser.user ) return;

        // إذا لم يكن هناك رمز مصادقة، التوجيه لصفحة المصادقة
        if ( !token )
        {
            navigate( "/auth", { replace: true } );
            return;
        }

        // جلب بيانات المستخدم
        fetchUser();
        // تعطيل التحذير من الـ ESLint لأن التبعيات محددة بشكل صحيح
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ token, inheritedUser ] ); // إعادة التشغيل عند تغيير الرمز أو المستخدم الموروث

    // إذا كان المستخدم موجوداً في السياق (موروث من المكون الأب)
    if ( inheritedUser.user )
    {
        // التحقق من أن دور المستخدم مسموح به
        return allowedRole.includes( inheritedUser.user.role )
            ? <Outlet /> // عرض المكونات الفرعية إذا كان مسموحاً
            : <Error403 role={ inheritedUser.user.role } />; // عرض صفحة خطأ 403 إذا غير مسموح
    }

    // إذا لم يكن هناك رمز مصادقة، إرجاع null (التوجيه تم بالفعل في useEffect)
    if ( !token ) return null;

    // إذا كانت بيانات المستخدم المحلية لا تزال قيد التحميل، عرض مكون التحميل
    if ( localUser === null ) return <Loding />;

    // التحقق من صلاحية دور المستخدم المحلي
    if ( !allowedRole.includes( localUser.role ) )
    {
        // عرض صفحة خطأ 403 مع دور المستخدم
        return <Error403 role={ localUser.role } />;
    }

    // إذا كان كل شيء صحيحاً، توفير سياق المستخدم للمكونات الفرعية
    return (
        <CurrentUserContext.Provider value={ { user: localUser, refetchUser: fetchUser } }>
            <Outlet /> {/* عرض المكونات الفرعية */ }
        </CurrentUserContext.Provider>
    );
}